import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import Button from "../Button/Button";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./wizard.scss";

const isForwardRefComponent = (component) => {
  return (
    typeof component === "object" &&
    component["$$typeof"] === Symbol.for("react.forward_ref")
  );
};

class Wizard extends React.Component {
  constructor(props) {
    super(props);
    let width;
    if (this.props.steps.length === 1) {
      width = "100%";
    } else {
      if (window.innerWidth < 600) {
        if (this.props.steps.length !== 3) {
          width = "50%";
        } else {
          width = 100 / 3 + "%";
        }
      } else {
        if (this.props.steps.length === 2) {
          width = "50%";
        } else {
          width = 100 / 3 + "%";
        }
      }
    }
    this.state = {
      currentStep: 0,
      highestStep: 0,
      color: this.props.color !== undefined ? this.props.color : "primary",
      nextButton: this.props.steps.length > 1,
      previousButton: false,
      finishButton: this.props.steps.length === 1,
      width: width,
      wizardData: this.props.wizardData !== undefined ? this.props.wizardData : {},
      movingTabStyle: {
        transition: "transform 0s",
      },
    };
    this.navigationStepChange = this.navigationStepChange.bind(this);
    this.refreshAnimation = this.refreshAnimation.bind(this);
    this.previousButtonClick = this.previousButtonClick.bind(this);
    this.nextButtonClick = this.nextButtonClick.bind(this);
    this.finishButtonClick = this.finishButtonClick.bind(this);
  }

  componentDidMount() {
    this.refreshAnimation(0);
    window.addEventListener("resize", this.updateWidth.bind(this));
  }

  componentWillUnmount() {
    this.isCancelled = true;
    window.removeEventListener("resize", this.updateWidth);
    var id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }

  updateWidth() {
    !this.isCancelled &&
      setTimeout(() => this.refreshAnimation(this.state.currentStep), 200);
  }

  navigationStepChange(key) {
    if (this.props.navSteps) {
      var validationState = true;
      if (this.props.validate && key > this.state.currentStep) {
        for (var i = this.state.currentStep; i < key; i++) {
          if (
            this.refs[this.props.steps[i].stepName].isValidated !== undefined &&
            this.refs[this.props.steps[i].stepName].isValidated() === false
          ) {
            validationState = false;
            break;
          }
        }
      }
      if (validationState) {
        this.setState({
          wizardData: {
            ...this.state.wizardData,
            [this.props.steps[this.state.currentStep].stepName]:
              this.refs[this.props.steps[this.state.currentStep].stepName]?.state || {},
          },
          currentStep: key,
          highestStep: key > this.state.highestStep ? key : this.state.highestStep,
          nextButton: this.props.steps.length > key + 1 ? true : false,
          previousButton: key > 0 ? true : false,
          finishButton: this.props.steps.length === key + 1 ? true : false,
        });
        this.refreshAnimation(key);
      }
    }
  }

  nextButtonClick() {
    if (
      this.props.validate
        ? this.refs[this.props.steps[this.state.currentStep].stepName].isValidated()
        : true
    ) {
      var key = this.state.currentStep + 1;
      this.setState({
        wizardData: {
          ...this.state.wizardData,
          [this.props.steps[this.state.currentStep].stepName]:
            this.refs[this.props.steps[this.state.currentStep].stepName]?.state || {},
        },
        currentStep: key,
        highestStep: key > this.state.highestStep ? key : this.state.highestStep,
        nextButton: this.props.steps.length > key + 1 ? true : false,
        previousButton: key > 0 ? true : false,
        finishButton: this.props.steps.length === key + 1 ? true : false,
      });
      this.refreshAnimation(key);
    }
  }

  previousButtonClick() {
    var key = this.state.currentStep - 1;
    if (key >= 0) {
      this.setState({
        wizardData: {
          ...this.state.wizardData,
          [this.props.steps[this.state.currentStep].stepName]:
            this.refs[this.props.steps[this.state.currentStep].stepName]?.state || {},
        },
        currentStep: key,
        highestStep: key > this.state.highestStep ? key : this.state.highestStep,
        nextButton: this.props.steps.length > key + 1 ? true : false,
        previousButton: key > 0 ? true : false,
        finishButton: this.props.steps.length === key + 1 ? true : false,
      });
      this.refreshAnimation(key);
    }
  }

  finishButtonClick() {
    if (
      this.props.validate
        ? this.refs[this.props.steps[this.state.currentStep].stepName].isValidated()
        : true
    ) {
      this.setState(
        {
          wizardData: {
            ...this.state.wizardData,
            [this.props.steps[this.state.currentStep].stepName]:
              this.refs[this.props.steps[this.state.currentStep].stepName]?.state || {},
          },
        },
        () => {
          this.props.finishButtonClick(this.state.wizardData);
        }
      );
    }
  }

  refreshAnimation(index) {
    var total = this.props.steps.length;
    var li_width = 100 / total;

    var total_steps = this.props.steps !== undefined ? this.props.steps.length : 0;
    var move_distance =
      this.wizardRef !== undefined
        ? this.navStepsLiRef.children[0].clientWidth / total_steps
        : 0;
    var index_temp = index;
    var vertical_level = 0;

    var mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      move_distance = this.navStepsLiRef.children[0].clientWidth / 2;
      index_temp = index % 2;
      li_width = 50;
    }

    this.setState({width: li_width + "%"});

    var step_width = move_distance;

    move_distance = move_distance * index_temp;

    if (mobile_device) {
      vertical_level = parseInt(index / 2);
      vertical_level = vertical_level * 38;
    }

    var movingTabStyle = {
      width: step_width,
      transform: "translate3d(" + move_distance + "px, " + vertical_level + "px, 0)",
      transition: "all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)",
    };
    this.setState({
      movingTabStyle: movingTabStyle,
    });
  }

  renderComponent(step) {
    const {component, stepProps, stepName} = step;
    if (typeof component === "function" || isForwardRefComponent(component)) {
      return (
        <step.component
          ref={(ref) => {
            this.refs[stepName] = ref;
          }}
          wizardData={this.state.wizardData}
          {...stepProps}
        />
      );
    }

    return (
      <div
        ref={(ref) => {
          this.refs[stepName] = ref;
        }}
      >
        {component}
      </div>
    );
  }

  render() {
    const {title, description, steps} = this.props;
    return (
      <div
        className="wizard-container"
        ref={(input) => {
          this.wizardRef = input;
        }}
      >
        {" "}
        <Card className="card card-wizard active" data-color={this.state.color}>
          <CardHeader
            className={this.props.headerTextCenter !== undefined ? "text-center" : ""}
            data-background-color={this.state.color}
          >
            {title && <CardTitle tag="h3">{title}</CardTitle>}
            {description && <h3 className="description">{description}</h3>}
            <div
              className="wizard-navigation"
              ref={(input) => (this.navStepsLiRef = input)}
            >
              {" "}
              <Nav pills>
                {steps.map((step, key) => {
                  return (
                    <NavItem key={key} style={{width: this.state.width}}>
                      <NavLink
                        className={classnames({
                          "active-wizard-header": key === this.state.currentStep,
                        })}
                        onClick={() => this.navigationStepChange(key)}
                      >
                        {step.stepName}
                      </NavLink>
                    </NavItem>
                  );
                })}
              </Nav>
            </div>
          </CardHeader>
          <CardBody>
            <TabContent activeTab={this.state.currentStep}>
              {steps.map((step, key) => {
                return (
                  <TabPane
                    tabId={key}
                    key={key}
                    className={classnames("fade", {
                      show: this.state.currentStep === key,
                    })}
                  >
                    {this.renderComponent(step)}
                  </TabPane>
                );
              })}
            </TabContent>
          </CardBody>
          <CardFooter>
            <div style={{float: "right"}}>
              {this.state.nextButton && (
                <Button onClick={() => this.nextButtonClick()} data-cy={"next-btn"}>
                  {this.props.nextButtonText !== undefined
                    ? this.props.nextButtonText
                    : "Next"}
                </Button>
              )}
              {this.state.finishButton && (
                <Button onClick={() => this.finishButtonClick()} data-cy={"finish-btn"}>
                  {this.props.finishButtonText !== undefined
                    ? this.props.finishButtonText
                    : "Finish"}
                </Button>
              )}
            </div>
            <div style={{float: "left"}}>
              {this.state.previousButton && (
                <Button onClick={() => this.previousButtonClick()} type={"info-small"}>
                  {this.props.previousButtonText !== undefined
                    ? this.props.previousButtonText
                    : "Previous"}{" "}
                </Button>
              )}
            </div>
          </CardFooter>
        </Card>
      </div>
    );
  }
}

Wizard.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepName: PropTypes.string.isRequired,
      stepIcon: PropTypes.string,
      component: PropTypes.element,
      stepProps: PropTypes.object,
    })
  ).isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  finishButtonClick: PropTypes.func,
  color: PropTypes.oneOf(["primary", "green", "orange", "red", "blue"]),
  previousButtonText: PropTypes.string,
  nextButtonText: PropTypes.string,
  finishButtonText: PropTypes.string,
  previousButtonClasses: PropTypes.string,
  nextButtonClasses: PropTypes.string,
  finishButtonClasses: PropTypes.string,
  headerTextCenter: PropTypes.bool,
  validate: PropTypes.bool,
  navSteps: PropTypes.bool,
};

export default Wizard;
